import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LoginForm } from "@/components/forms/login-form";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export const LoginModal = () => {
  const { t } = useTranslation();

  const [isOpen, onOpenChange] = useState(false);

  return (
    <Dialog onOpenChange={onOpenChange} open={isOpen}>
      <DialogTrigger asChild>
        <Button className="text-white" size="sm" variant="ghost">
          Login
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("login.title")}</DialogTitle>
          <DialogDescription>{t("login.description")}</DialogDescription>
        </DialogHeader>

        <LoginForm
          className="space-y-6"
          isOpen={isOpen}
          onOpenChange={onOpenChange}
        />
      </DialogContent>
    </Dialog>
  );
};
